import { Webhook } from 'lucide-react';

// Single source of truth for the colour marks (owner, 2026-10-23: unify the Enterprise-row
// treatment across the infra diagram and the session-ledger CRM card — no more monochrome
// BrandMark). Sources are cited in `public/logos/README.md`.
export const LOGO_SRC: Record<string, string> = {
  Salesforce: '/logos/salesforce-color.svg',
  HubSpot: '/logos/hubspot-color.svg',
  Zoho: '/logos/zoho-color.svg',
  Slack: '/logos/slack-color.svg',
  Teams: '/logos/teams.svg',
  Jira: '/logos/jira-color.svg',
  Linear: '/logos/linear-color.svg',
};

const integrations = ['Salesforce', 'HubSpot', 'Zoho', 'Slack', 'Teams', 'Webhooks'] as const;

export function IntegrationLogos() {
  return (
    <ul className="fx-marks" aria-label="Integrations">
      {integrations.map((name) => (
        <li className="fx-integration" key={name}>
          <span className="fx-integration-logo">
            {LOGO_SRC[name] ? (
              <img src={LOGO_SRC[name]} alt="" width="64" height="36" loading="lazy" />
            ) : (
              <Webhook size={28} strokeWidth={1.5} aria-hidden="true" />
            )}
          </span>
          <span className="fx-integration-label">{name}</span>
        </li>
      ))}
    </ul>
  );
}

/**
 * Compact inline colour mark — same brand SVGs as the Enterprise row above, sized for a chip
 * (infra diagram node chips, the session-ledger CRM artifact card). Replaces the monochrome
 * `BrandMark`: the owner's call is the colour treatment everywhere, not a dimmed currentColor
 * recreation. `dir` keeps the "· direction" suffix visible (Jira/Linear are direction-only).
 */
export function ColorMark({ name, dir = false, size = 20 }: { name: string; dir?: boolean; size?: number }) {
  const src = LOGO_SRC[name];
  return (
    <span className={`fx-mark${dir ? ' dir' : ''}`} data-mark={name}>
      <span className="fx-mark-logo">
        {src ? (
          <img src={src} alt="" width={Math.round(size * 1.8)} height={size} loading="lazy" />
        ) : (
          <Webhook size={size - 4} strokeWidth={2.5} aria-hidden="true" />
        )}
      </span>
      {name}
      {dir && <span className="fx-mark-dir"> · direction</span>}
    </span>
  );
}
